var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"to-dashboard-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v(" Back to dashboard ")])
}
var staticRenderFns = []

export { render, staticRenderFns }